import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
  },
  cards: {
    padding: theme.spacing(2),
  },
}))

export default useStyles
